import { toYYYYMMDD } from "src/utils/datefns";


function isAvailable (date: Date, availability: any[] | undefined) {
    if (availability && availability.length) {
        return availability.find(data => {
          if (!data) return false;
          return data === toYYYYMMDD(date)
        })
    }
    return true;
}

export function filterDate(date: Date, weekdaysBlocked: undefined | any[], availability: undefined | any[], checkAvailable?: (data: any) => boolean) {
    // check by week days blocked:
    if (weekdaysBlocked && weekdaysBlocked.length && weekdaysBlocked.some(wd => wd === date.getDay())) return false;
    
    // check by availability:
    if (!isAvailable(date, availability)) return false;

    // check by dynamic hook:
    if (checkAvailable && !checkAvailable(date)) return false;

    // passes the filters.
    return true;
}

export function getDayClassnameForDatepicker(
    date: Date,
    currentValue: Date | undefined,
    availability: any[] | undefined,
    weekdaysBlocked: any[] | undefined,
) {
    const classes = ["font-semibold datepicker-day"];
    if (currentValue && currentValue.setHours(0,0,0,0) === date.setHours(0,0,0,0)) classes.push('datepicker-day-selected');
    if (weekdaysBlocked && weekdaysBlocked.length && !filterDate(date, weekdaysBlocked, availability)) classes.push("day-not-available");
    if (availability && isAvailable(date, availability)) classes.push("day-available");
    return classes.join(" ");
}

export function getDayClassnameForDateRangePicker (
    date: Date,
    hoverDate: Date | undefined,
    startDate: Date | undefined,
    endDate: Date | undefined,
    availability: any[] | undefined,
    weekdaysBlocked: any[] | undefined,
) {
    const classes = ["font-semibold datepicker-day"];
    if (startDate && startDate.setHours(0,0,0,0) === date.setHours(0,0,0,0)) classes.push('datepicker-day-selected');
    if (hoverDate && hoverDate.setHours(0,0,0,0) === date.setHours(0,0,0,0)) classes.push('datepicker-day-hover');
    if (hoverDate && startDate && !endDate && date >= startDate && date <= hoverDate) classes.push('datepicker-day-range');
    if (weekdaysBlocked && weekdaysBlocked.length && !filterDate(date, weekdaysBlocked, availability)) classes.push("day-not-available");
    if (availability && isAvailable(date, availability)) classes.push("day-available");
    return classes.join(" ");
}

export function getDayNameLocalized(nameOfDay: "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday", locale: string = "en") {
    const weekDays = {
      Monday: new Date(1970, 5, 1),
      Tuesday: new Date(1970, 5, 2),
      Wednesday: new Date(1970, 5, 3),
      Thursday: new Date(1970, 5, 4),
      Friday: new Date(1970, 5, 5),
      Saturday: new Date(1970, 5, 6),
      Sunday: new Date(1970, 5, 7),
    };
  
    const dayFormatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    const formatted = dayFormatter.format(weekDays[nameOfDay])
    const capitalized = formatted[0].toUpperCase() + formatted.substring(1);
    return capitalized.replace('.', '').substring(0, 2);
  }
  

